import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  Fragment,
} from "react";
import { AppContext } from "../../components/States/AppContext";
import { Link } from "react-router-dom";

// components
import { NumericBox1 } from "../../components/MainButtons/NumericBoxes";
import TopBar from "../../components/MonitorComponents/TopBar";
import MessageBox from "../../components/MonitorComponents/MessageBox";
import PatientDemo from "../../components/MonitorComponents/PatientDemo";
import VideoPlayer from "../../components/Common/VideoPlayer";

//image
import plethFlatVertical from "../../img/waveforms/plethverticalnew.mp4";

//styles
import {
  LandScapeContainer,
  Landscapeflex,
  WaveContainer,
  WaveVidLandscape,
} from "./LandScapePage.elements";

const LandscapePage = () => {
  const { state, setState } = useContext(AppContext);

  const primaryWaves = state.waveData
    .filter((wave) => wave.primary || wave.secondary)
    .sort((wave1, wave2) => {
      if (wave1.primary && !wave2.primary) {
        return -1;
      } else if (!wave1.primary && wave2.primary) {
        return 1;
      } else {
        return 0;
      }
    });

  const primaryWave = primaryWaves.map((wave, key) => {
    return (
      <Fragment key={key}>
        {wave.primary && (
          <Link style={{ gridArea: "vwave1" }}>
            {wave.name === "Pleth" ? (
              <VideoPlayer
                src={state.spoContinuous ? wave.verticalVid : plethFlatVertical}
                autoPlay
                playsInline
                loop
                muted
                loading="eager"
                style={{
                  width: "100%",
                  margin: "auto",
                  height: "100%",
                  objectFit: "fill",
                }}
                ecgOff={
                  state.ecgOffWave2 === true && state.spoContinuous === false
                }
              />
            ) : (
              <VideoPlayer
                src={wave.verticalVid}
                autoPlay
                playsInline
                loop
                muted
                loading="eager"
                style={{
                  width: "100%",
                  margin: "auto",
                  height: "100%",
                  objectFit: "fill",
                }}
                ecgOff={
                  state.ecgOffWave2 === true && state.spoContinuous === false
                }
              />
            )}
          </Link>
        )}
      </Fragment>
    );
  });

  const secondaryWave = primaryWaves.map((wave, key) => {
    return (
      <Fragment key={key}>
        {wave.secondary && (
          <Link style={{ gridArea: "vwave2" }} key={key}>
            {wave.name === "Pleth" ? (
              // <WaveVidLandscape
              //   disablePictureInPicture
              //   src={state.spoContinuous ? wave.verticalVid : plethFlatVertical}
              //   autoPlay
              //   playsInline
              //   loop
              //   muted
              //   loading="eager"
              //   style={{
              //     width: "100%",
              //     margin: "auto",
              //     height: "100%",
              //     objectFit: "fill",
              //   }}
              //   ecgOff={
              //     state.ecgOffWave2 === true && state.spoContinuous === false
              //   }
              // />
              <VideoPlayer
                src={state.spoContinuous ? wave.verticalVid : plethFlatVertical}
                autoPlay
                playsInline
                loop
                muted
                loading="eager"
                style={{
                  width: "100%",
                  margin: "auto",
                  height: "100%",
                  objectFit: "fill",
                }}
                ecgOff={
                  state.ecgOffWave2 === true && state.spoContinuous === false
                }
              />
            ) : (
              // <WaveVidLandscape
              //   disablePictureInPicture
              //   src={wave.verticalVid}
              //   autoPlay
              //   playsInline
              //   loop
              //   muted
              //   loading="eager"
              //   style={{
              //     width: "100%",
              //     margin: "auto",
              //     height: "100%",
              //     objectFit: "fill",
              //   }}
              //   ecgOff={
              //     state.ecgOffWave2 === true && state.spoContinuous === false
              //   }
              // />
              <VideoPlayer
                src={wave.verticalVid}
                autoPlay
                playsInline
                loop
                muted
                loading="eager"
                style={{
                  width: "100%",
                  margin: "auto",
                  height: "100%",
                  objectFit: "fill",
                }}
                ecgOff={
                  state.ecgOffWave2 === true && state.spoContinuous === false
                }
              />
            )}
          </Link>
        )}
      </Fragment>
    );
  });

  return (
    <LandScapeContainer>
      <TopBar />
      <MessageBox landscape />
      <PatientDemo />
      <Landscapeflex>
        <NumericBox1 number={1} landscape />
        <NumericBox1 number={2} landscape />
        <NumericBox1 number={3} landscape />
      </Landscapeflex>

      <WaveContainer>
        {primaryWave}
        {secondaryWave}
      </WaveContainer>
    </LandScapeContainer>
  );
};

export default LandscapePage;
